import React, { useState, useEffect } from 'react';
import { X, Gift, ArrowRight } from 'lucide-react';
import '../styles/ExitIntentPopup.css';

const ExitIntentPopup = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    
    try {
      // Send to backend for tracking
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/exit-capture`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          email, 
          source: 'exit_intent',
          timestamp: new Date().toISOString()
        })
      });

      if (response.ok) {
        setIsSubmitted(true);
        // Store in localStorage so we don't show popup again
        localStorage.setItem('exitIntentCaptured', 'true');
      }
    } catch (error) {
      console.error('Exit capture error:', error);
      // Still mark as submitted to close popup
      setIsSubmitted(true);
      localStorage.setItem('exitIntentCaptured', 'true');
    }

    setIsSubmitting(false);
  };

  if (isSubmitted) {
    return (
      <div className="exit-popup-overlay">
        <div className="exit-popup">
          <button className="exit-popup-close" onClick={onClose}>
            <X size={24} />
          </button>
          <div className="exit-popup-success">
            <div className="success-icon">✓</div>
            <h2>You're In!</h2>
            <p>Check your inbox for your free business guide.</p>
            <button className="btn-primary" onClick={onClose}>
              Continue Browsing
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="exit-popup-overlay">
      <div className="exit-popup">
        <button className="exit-popup-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <div className="exit-popup-content">
          <div className="exit-popup-icon">
            <Gift size={48} />
          </div>
          
          <h2 className="exit-popup-title">Wait! Don't Leave Empty-Handed</h2>
          <p className="exit-popup-subtitle">
            Get our <strong>FREE Business Growth Checklist</strong> — the same framework we use to evaluate businesses worth $50K–$2M.
          </p>

          <form onSubmit={handleSubmit} className="exit-popup-form">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              className="exit-popup-input"
            />
            <button 
              type="submit" 
              className="btn-primary exit-popup-btn"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Sending...' : 'Get Free Checklist'}
              <ArrowRight size={20} />
            </button>
          </form>

          <p className="exit-popup-disclaimer">
            No spam, ever. Unsubscribe anytime.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ExitIntentPopup;
